/**
 * @author Ariel
 * @description 考试记录管理
 * @Date 2020/02/03
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";
import { component_tool, framework_tool } from '../../../tool';
import createStudentAnswerExportColumns from "./studentAnswerExportColumns";
import createQuestionAnswerExportColumns from "./questionAnswerExportColumns";
import createGradeColumns from "./gradeExportColumns"

let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;

function getStudentAnswerDetailData( chapter) {
  let dataInfo = []
  if (chapter && chapter.length) {
    //dataInfo = chapter
    chapter.forEach(e => {
      if (e['examPaperChapters'] && e['examPaperChapters'].length) {
        e['examPaperChapters'].forEach(q => {
          if (q['questions'] && q['questions'].length) {

            q['questions'].forEach((a,index) => {
              e[index + '_' + 'title'] = a['title']
              e[index + '_' + 'number'] = a['number']
              e[index + '_' + 'type'] =  _getValue('questionType', a['type'])
              e[index + '_' + 'correct'] = a['correct']
              e[index + '_' + 'answer'] = a['answer']
            })
          }
        })
      }
      let {examPaperChapters,...other} = e
      dataInfo.push(other)
    })
  }
  return dataInfo;
}


function getQuestionAnswerDetailData(data) {
  let dataInfo = []
  if (data && data.length) {
    dataInfo = data
    dataInfo.forEach(e => {
      if (e['question']) {
        e['categoryName'] = e['question'].categoryName
        e['number'] = e['question'].number
        e['type'] = _getValue("questionType", e['question'].type)
        e['title'] = e['question'].title
        e['img'] = e['question'].img
        e['optionContents'] = e['question'].optionContents
        e['correctContent'] = e['question'].correctContent
        if (e['question'].options && e['question'].options.length) {
          e['question'].options.forEach(q => {
            e[q['opt'] + '_' + 'content'] = q['content']
            e[q['opt'] + '_' + 'optNumber'] = q['optNumber']
            e[q['opt'] + '_' + 'optRate'] = q['optRate']
          });
        }
      }
    })
  }
  return dataInfo;
}

const _getValue = (type, key) => {
  const values = {
    status: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    face: {
      1: '已开启',
      0: '未开启',
    },
    scoreRule: {
      0: '最高分',
      1: '平均分',
    },
    questionType: {
      0: '单选题',
      1: '多选题',
      2: '判断题',
      3: '填空题',
      4: '主观题',
      6: '文件上传题',
      7: '排序',
    },
    faceAuthStatus:{
      0: '否',
      1: '是',
      2: '',
    },
    examType: {
      '0': '独立考试',
      '1': '课程考试',
      '0,1': '独立考试、课程考试',
      '1,0': '独立考试、课程考试'
    }
  }
  return values[type][key]
}

class ExamRecordManager extends WizContainer {
  componentName = 'examRecordManager';

  constructor(props) {
    super(props);
    const {history} = props
    let pathname = '/online/examRecord'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/examRecordPerm')) {
      pathname = '/perm/examRecordPerm'
    }
    this.state = {
    }
    this.pathname = pathname
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '考试名称',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '考试分类',
        field: 'categoryName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '考试类型',
        field: 'examType',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "考试受众",
        field: "target",
        width: 100,
        cellStyle: {
          padding: "5px 0",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
        },
      },
      // {
      //   headerName: "关联内容",
      //   field: "relationContent",
      //   width: 20,
      //   cellStyle: {
      //     textAlign: "center",
      //   },
      //   style: {
      //     alignment: {vertical: "bottom", horizontal: "left", wrapText: true},
      //   },
      // },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'status',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '已交卷人数',
        field: 'completeNum',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '已通过人数',
        field: 'passNum',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      // {
      //   headerName: '身份验证',
      //   field: 'face',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '是否有待审核',
      //   field: 'faceAuthStatus',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      // {
      //   headerName: '待审核',
      //   field: 'faceAuthCount',
      //   width: 15,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      {
        headerName: "考试时长(分钟)",
        field: "limitMinutes",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "允许重复考试次数",
        field: "count",
        width: 20,
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: '总分',
        field: 'totalScore',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '通过分数',
        field: 'passScore',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '成绩规则',
        field: 'scoreRule',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      // const examTypeEnum = ['独立考试', '课程考试'];
      let data = Object.assign([], o['data'])
      data.forEach((val, index) => {
        if (val['exam']) {
          val['status'] = _getValue('status', val['exam'].status)
          val['face'] = _getValue('face', val['exam'].face)
          val['scoreRule'] = _getValue('scoreRule', val['exam'].scoreRule)
          val['limitMinutes'] = val['exam'].limitMinutes
          val['count'] = val['exam'].count
          val['totalScore'] = val['exam'].totalScore
          val['passScore'] = val['exam'].passScore
          val['examType'] = _getValue('examType',val['exam'].examType)
          val['faceAuthStatus'] = _getValue('faceAuthStatus', val['faceAuthStatus']);
          let face = val['exam'].face;
          val['faceAuthCount'] = (face!=null && face===1 ? val['faceAuthCount'] && val['faceAuthCount']  : '');
        }
        let authData = val['targetScoreInfo']
        let target = ''
        let shouldExamNum = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] + '(' + org['fullName'] + '),'
            });
            target += '\n'
          }
          if (authData['scopeCount']) {
            shouldExamNum = authData['scopeCount']
          } else {
            shouldExamNum = 0
          }

        }
        val['target'] = target
        val['shouldExamNum'] = shouldExamNum
      })
      WizBrowserExport({
        title: '考试记录管理信息',
        sheetName: '考试记录管理信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '考试记录管理信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _exportByPositionFile(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let examName = o['data']['examName']
      let data = o['data']['list']
      data && data.length && data.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
      });
      let columnDefs = createGradeColumns(this)
      WizBrowserExport({
        title: examName+'-按选择任职导出成绩',
        sheetName: examName+'-按选择任职导出成绩',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: examName+'-按选择任职导出成绩.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _exportByPositionInfoFile(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let examName = o['data']['examName']
      let data = o['data']['list']
      data && data.length && data.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
      });
      let columnDefs = createGradeColumns(this)
      WizBrowserExport({
        title: examName+'-按任职情况导出成绩',
        sheetName: examName+'-按任职情况导出成绩',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: examName+'-按任职情况导出成绩.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _exportByStudentAnswerDetailFile(nextProps, nextState, key) {
    let title = nextProps?.apis?.exportByStudentAnswerDetail?.payload?.apiParams?.examTitle
    if(title){
      title = title+"-"
    }
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = title+'学员答题情况.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
  }

  _exportByQuestionAnswerDetailFile(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data']
      let examName = ""
      data && data.length && data.some(d => {
        if (d && d.examName) {
          examName = d.examName
          return true
        }
      })
      let columnDefs = createQuestionAnswerExportColumns(this, data)
      let dataInfo = getQuestionAnswerDetailData(data)
      WizBrowserExport({
        title: examName+'-题库出题情况',
        sheetName: examName+'-题库出题情况',
        columns: columnDefs.filter((_, index) => index),
        rows: dataInfo,
        filename: examName+'-题库出题情况.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateConfig(this, {
      templateConfig: templateConfig({pathname: this.pathname}),
      apiDataFormat: {
        export: this._handleFile,
        exportByPosition: this._exportByPositionFile,
        exportByPositionInfo: this._exportByPositionInfoFile,
        exportByStudentAnswerDetail: this._exportByStudentAnswerDetailFile,
        exportByQuestionAnswerDetail: this._exportByQuestionAnswerDetailFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ExamRecordManager);
